import { Lightning, Utils, Storage, Router } from "@lightningjs/sdk";

import { gridHeight, gridWidth } from "../../services/grid.service";

import { pathNames } from "../../lib/routes";

import { ReportingService, ViewNames } from "../../services/reporting.service";
import { Store } from "../../services/app.store.service";

export default class Splash extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      w: 1920,
      h: 1080,
      color: 0xff000000,
      Logo: {
        LogoImage: {
          w: 7 * gridWidth,
          h: 7 * gridHeight,
          x: 8.5 * gridWidth,
          y: 8.5 * gridHeight,
          Img: {
            w: 7 * gridWidth,
            h: 7 * gridHeight,
            src: Utils.asset("images/xiteLogo.png"),
          },
        },
      },
    };
  }

  _init() {
    this.radiostations = Store.radiostations;
  }

  _getFocused() {
    return this;
  }

  async _active() {
    this.application.emit("loader_animation_start", {});
    setTimeout(() => {
      this.application.emit("loader_animation_stop", {});
      Router.resume();
    }, 1000);

    ReportingService.trackStart();

    ReportingService.trackViewChange(ViewNames.Store, ViewNames.SplashScreen, false);

    Storage.set("sourceViewName", ViewNames.SplashScreen);
  }
}
